import getTilePositionFromRowPosition from "../getTilePositionFromRowPosition";
import config from "../../config/common";

const addLoyaltyBanner = ({
  viewportCategory,
  positionFinder,
  items,
  BannerComponent,
}) => {
  const {
    loyalty: { bannerInsertAtRow },
  } = config;

  const outputItems = [...items];

  const targetPosition = getTilePositionFromRowPosition({
    viewportCategory,
    rowPosition: bannerInsertAtRow,
  });

  const targetIndexInItemsArray = positionFinder({
    configuredPosition: targetPosition,
    items: [...outputItems],
  });

  if (targetIndexInItemsArray >= outputItems.length) {
    return outputItems;
  }

  outputItems.splice(targetIndexInItemsArray, 0, BannerComponent);

  return outputItems;
};

export default addLoyaltyBanner;
